import { Link } from 'react-router-dom'
import {
  accountPlanBadges,
  accountPlanSummaryLine,
  type AccountPlanBadge as PlanBadge,
} from '@proffer/shared'
import { useAuth } from '../auth/AuthContext'

const toneClass: Record<PlanBadge['tone'], string> = {
  violet:
    'border-violet-200/80 bg-violet-50 text-violet-800 dark:border-violet-800/60 dark:bg-violet-950/50 dark:text-violet-200',
  emerald:
    'border-emerald-200/80 bg-emerald-50 text-emerald-900 dark:border-emerald-800/60 dark:bg-emerald-950/40 dark:text-emerald-200',
  gold: 'border-amber-200/80 bg-amber-50 text-amber-950 dark:border-amber-800/60 dark:bg-amber-950/40 dark:text-amber-100',
  amber:
    'border-amber-200/80 bg-amber-50 text-amber-950 dark:border-amber-800/60 dark:bg-amber-950/40 dark:text-amber-100',
}

type Props = {
  /** `compact` = μικρότερα· το includes μόνο στο tooltip */
  compact?: boolean
  className?: string
}

export function AccountPlanBadge({ compact = false, className = '' }: Props) {
  const { user } = useAuth()
  if (!user) return null

  const input = {
    plan: user.plan,
    billingTier: user.billingTier,
    activePackages: user.activePackages,
    proTrialActive: user.proTrialActive,
    proTrialDaysRemaining: user.proTrialDaysRemaining,
  }
  const badges = accountPlanBadges(input)
  if (badges.length === 0) return null

  const summary = accountPlanSummaryLine(input)

  return (
    <Link
      to="/billing"
      title={`Πακέτο: ${summary} — λεπτομέρειες συνδρομής`}
      className={`inline-flex max-w-full flex-col gap-0.5 hover:opacity-90 ${className}`}
    >
      {badges.map((badge) => (
        <span key={badge.label} className="inline-flex max-w-full flex-col gap-0.5">
          <span
            className={`inline-flex max-w-full items-center truncate rounded-lg border px-2 py-0.5 font-semibold ${
              compact ? 'text-[10px]' : 'text-[11px]'
            } ${toneClass[badge.tone]}`}
          >
            {badge.label}
          </span>
          {badge.includes && !compact ? (
            <span className="truncate text-[9px] font-medium leading-tight text-zinc-500 dark:text-zinc-400">
              {badge.includes}
            </span>
          ) : null}
        </span>
      ))}
    </Link>
  )
}
